import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableLoanOfficerName extends Component<{ fullName: string }> {
    render() {
        return <OptionalTableCell title='Loan Officer'>
            {this.props.fullName}
        </OptionalTableCell>;
    }
}